<template lang="pug">
div(@click.stop="onBtn"
  :class="{'active': active}").wrap-button.f.fh.rounded.cursor-pointer.py14.h50
  v-progress-circular(v-if="isSaving"
    width="3" size="20" color="white" indeterminate).py4
  span(v-else="isSaving").fz14.bold {{label}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
.wrap-button {
  width: 100%;
  background: $deactive_color;
  &.active {
    background: $active_color;
  }
  span {
    color: $dark_primary_text_color;
  }
}
</style>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    action: {
      type: Function,
      required: true
    },
    active: {
      type: Boolean,
      default: true
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onBtn () {
      if (this.active) {
        this.action()
      }
    }
  }
}
</script>
